import { Route as PurchaseRequestsRoute } from "@/routes/(pharma)/_layout/reports/purchase-requests-list/index";
import { useQuery } from "@tanstack/react-query";
import { getPurchaseRequests } from "../-data/api";

interface PurchaseRequestsQueryResult {
  purchaseRequests: any[];
  totalCount: number;
}

export const usePurchaseRequestsData = () => {
  const searchParams = PurchaseRequestsRoute.useSearch();
  
  return useQuery<PurchaseRequestsQueryResult>({
    queryKey: ["purchase-requests", searchParams],
    queryFn: async () => {
      return await getPurchaseRequests(
        searchParams.page || 1,
        searchParams.pageSize || 10
      );
    },
    placeholderData: (previousData) => previousData,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};